import { render, staticRenderFns } from "./shineHomework.vue?vue&type=template&id=23343334&scoped=true"
import script from "./shineHomework.vue?vue&type=script&lang=ts"
export * from "./shineHomework.vue?vue&type=script&lang=ts"
import style0 from "./shineHomework.vue?vue&type=style&index=0&id=23343334&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23343334",
  null
  
)

export default component.exports